/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDomains200ResponseInner
 */
export interface GetDomains200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetDomains200ResponseInner
     */
    automaticPromotionId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDomains200ResponseInner
     */
    brandId: string;
    /**
     * 
     * @type {string}
     * @memberof GetDomains200ResponseInner
     */
    brandName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDomains200ResponseInner
     */
    commsLine?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDomains200ResponseInner
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof GetDomains200ResponseInner
     */
    logoLink?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDomains200ResponseInner
     */
    metaDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDomains200ResponseInner
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetDomains200ResponseInner
     */
    title?: string;
}

/**
 * Check if a given object implements the GetDomains200ResponseInner interface.
 */
export function instanceOfGetDomains200ResponseInner(value: object): value is GetDomains200ResponseInner {
    if (!('brandId' in value) || value['brandId'] === undefined) return false;
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    return true;
}

export function GetDomains200ResponseInnerFromJSON(json: any): GetDomains200ResponseInner {
    return GetDomains200ResponseInnerFromJSONTyped(json, false);
}

export function GetDomains200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDomains200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'automaticPromotionId': json['automaticPromotionId'] == null ? undefined : json['automaticPromotionId'],
        'brandId': json['brandId'],
        'brandName': json['brandName'] == null ? undefined : json['brandName'],
        'commsLine': json['commsLine'] == null ? undefined : json['commsLine'],
        'domain': json['domain'],
        'logoLink': json['logoLink'] == null ? undefined : json['logoLink'],
        'metaDescription': json['metaDescription'] == null ? undefined : json['metaDescription'],
        'organizationId': json['organizationId'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function GetDomains200ResponseInnerToJSON(json: any): GetDomains200ResponseInner {
    return GetDomains200ResponseInnerToJSONTyped(json, false);
}

export function GetDomains200ResponseInnerToJSONTyped(value?: GetDomains200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'automaticPromotionId': value['automaticPromotionId'],
        'brandId': value['brandId'],
        'brandName': value['brandName'],
        'commsLine': value['commsLine'],
        'domain': value['domain'],
        'logoLink': value['logoLink'],
        'metaDescription': value['metaDescription'],
        'organizationId': value['organizationId'],
        'title': value['title'],
    };
}

